import {Text, Box, Flex, SimpleGrid} from '@chakra-ui/react';
import {ResponsiveImageType} from 'react-datocms';
import {DatoCmsImage} from '../datocms/image';

interface TeamMemberType {
  name: string;
  role: string;
  image: {responsiveImage: ResponsiveImageType};
}

interface OurTeamProps {
  preTitle: string;
  title: string;
  teamMembers: TeamMemberType[];
}

export const OurTeam: React.FC<OurTeamProps> = ({
  preTitle,
  title,
  teamMembers,
}) => {
  return (
    <Box maxW="975px" margin="0 auto">
      <Flex direction="column" mb={{base: '24px', md: '48px'}}>
        <Text as="h6" textStyle="h6">
          {preTitle}
        </Text>
        <Text as="h3" textStyle={{base: 'h5', md: 'h3'}}>
          {title}
        </Text>
      </Flex>
      <SimpleGrid columns={{base: 2, md: 4}} gap={{base: '12px', md: '32px'}}>
        {teamMembers.map((teamMember) => (
          <Box>
            <Flex direction="column" alignItems="center" flexBasis="200px">
              <DatoCmsImage
                responsiveImage={teamMember.image.responsiveImage}
              />
              <Text as="h6" textStyle="h7" mt={{base: '8px', md: '12px'}}>
                {teamMember.name}
              </Text>
              <Text>{teamMember.role}</Text>
            </Flex>
          </Box>
        ))}
      </SimpleGrid>
    </Box>
  );
};
